import {h, Component} from 'preact';
import shallowCompare from 'preact-shallow-compare';
import Review from '@components/customerReviews/Review';
import isEmptyOrNil from '@util/fn/isEmptyOrNil';

class ReviewsList extends Component {
    shouldComponentUpdate ( nextProps, nextState ) {
        return shallowCompare( this, nextProps, nextState );
    }

    render ( {reviews, filters, openModal, onEditReview, onDeleteReview, onDeleteComment, onRespondReview, onDenyReview, isAdmin} ) {
        if ( isEmptyOrNil( reviews ) ) {
            return null;
        }

        return (
            <div data-testid="test-reviewList">
                {reviews.map( ( customerReview, index ) =>
                    <Review
                        key={customerReview.id}
                        index={index}
                        filters={filters}
                        {...customerReview}
                        isAdmin={isAdmin}
                        onEditReview={onEditReview}
                        onDeleteReview={onDeleteReview}
                        onDeleteComment={onDeleteComment}
                        onRespondReview={onRespondReview}
                        onDenyReview={onDenyReview}
                    />
                )}
            </div>
        );
    }
}

export default ReviewsList;